import { render, staticRenderFns } from "./LandingHeroAfiliado.vue?vue&type=template&id=3ca5c1cc&scoped=true"
import script from "./LandingHeroAfiliado.vue?vue&type=script&lang=js"
export * from "./LandingHeroAfiliado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca5c1cc",
  null
  
)

export default component.exports